// extracted by mini-css-extract-plugin
module.exports = {"form":"SignInModal_form__puneu"};